import React, { useState } from 'react';

/**
 * DiscountCode Component
 * Displays discount codes for businesses that offer them
 * Authentication and membership status are checked at the template level
 */
export default function DiscountCode({ code, title, description, analytics, variant = 'default' }) {
  const [copied, setCopied] = useState(false);
  const isPartner = variant === 'partner';

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      if (analytics) {
        analytics.trackInteraction('copy_discount_code', { code, title });
      }
    } catch (error) {
      console.error('Failed to copy code:', error);
    }
  };

  if (isPartner) {
    return (
      <div className="partner-offer-ticket">
        {title && (
          <p className="text-lg font-semibold text-stone-800 mb-2">{title}</p>
        )}
        {description && (
          <p className="text-stone-500 text-sm mb-6 leading-relaxed">{description}</p>
        )}
        <p className="text-[11px] font-bold uppercase tracking-widest text-stone-400 mb-4">
          Your code
        </p>
        <code className="block text-2xl md:text-3xl font-bold text-brand-700 font-mono tracking-tight mb-5">
          {code}
        </code>
        <button
          type="button"
          onClick={copyToClipboard}
          className="px-6 py-2.5 rounded-full bg-stone-900 text-white text-sm font-medium hover:bg-stone-800 transition-colors"
          title="Copy to clipboard"
        >
          {copied ? 'Copied' : 'Copy code'}
        </button>
        <p className="text-xs text-stone-400 mt-5">
          Present at checkout to redeem your member discount
        </p>
      </div>
    );
  }

  return (
    <div className="card bg-brand-50 border-2 border-brand-200 mt-8 mb-8">
      <div className="bg-white border-2 border-dashed border-brand-300 rounded-lg p-4 text-center">
        <p className="text-sm text-gray-600 mb-2">Your discount code:</p>
        <div className="flex items-center justify-center gap-3">
          <code className="text-2xl font-bold text-brand-800 font-mono">
            {code}
          </code>
          <button
            type="button"
            onClick={copyToClipboard}
            className="btn btn-secondary text-sm"
            title="Copy to clipboard"
          >
            {copied ? '✓ Copied!' : '📋 Copy'}
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-3">
          Present this code at checkout to receive your discount
        </p>
      </div>
    </div>
  );
}
